import { React, useEffect } from "react";
import TrainingBoard from "../components/TrainingBoard";
import GameDetails from "../components/GameDetails";
import Sidebar from "../components/Sidebar";
import { useGlobalContext } from "../context";
import ColorPicker from "../components/ColorPicker";

const Chess = require("chess.js");
let chess = new Chess();

const Training = () => {
  const { setIsGameOver, showColorPicker, setShowColorPicker, fen } =
    useGlobalContext();

  useEffect(() => {
    setIsGameOver(false);
    setShowColorPicker(false);
  }, []);

  return (
    <main>
      {/* <div className="section"> */}
      <div className={showColorPicker ? "section modal-in" : "section"}>
        <TrainingBoard chess={chess} />
        <GameDetails chess={chess} isTraining={true} />
      </div>
      <Sidebar />
      {showColorPicker && <ColorPicker chess={chess} fen={fen} />}
    </main>
  );
};

export default Training;
